/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react"

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types"

// @mui material components
import MenuItem from "@mui/material/MenuItem"
import Link from "@mui/material/Link"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

// custom styles for the NotificationItem
import menuItem from "monitor/Items/NotificationItem/styles"

const NotificationItem = forwardRef(({ icon, title, color = "secondary", ...rest }, ref) => (
  <MenuItem {...rest} ref={ref} sx={(theme) => ({
    ...menuItem(theme),
    "&:hover .ni-colored, &:focus .ni-colored": {
      color:
        color === "text"
          ? undefined
          : `${theme.palette[color]?.main || theme.palette.text.primary} !important`,
    },
  })}>
    <MDBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1} sx={{
      color: "inherit",
      textDecoration: "none",
      "&:hover": { textDecoration: "none" },
    }}>
      <MDTypography variant="body1" color={color} lineHeight={0.75} className="ni-colored" sx={{
        color: (theme) =>
          color === "text"
            ? undefined
            : `${theme.palette[color]?.main || theme.palette.text.primary} !important`,
      }}>
        {icon}
      </MDTypography>
      <MDTypography variant="button" fontWeight="regular" color={color}
        className="ni-colored"
        sx={{
          ml: 1,
          color: (theme) =>
            color === "text"
              ? undefined
              : `${theme.palette[color]?.main || theme.palette.text.primary} !important`,
        }}>
        {title}
      </MDTypography>
    </MDBox>
  </MenuItem>
))

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "text",
  ]),
};

export default NotificationItem
